module.exports = window["core-js/modules/es.array.from.js"];